module.exports = __webpack_public_path__ + "img/diversity-icon.e7d687c8.svg";